<template>
    <div class="account">
        <div class="top_header_fixed">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/flowConfig01List' }">流向商业配置</el-breadcrumb-item>
                <el-breadcrumb-item>{{ headerTitle }}</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="title_btn">
                <div>
                    <div>
                        <el-button size="small" plain @click="insert">新增</el-button>
                        <el-button size="small" plain @click="copy">复制</el-button>
                        <el-button size="small" plain @click="update">编辑</el-button>
                        <el-button size="small" plain @click="disable">禁用</el-button>
                        <el-button size="small" plain @click="del">删除</el-button>
                        <draggableDetail :draggable="{ data_name: 'commodity_flow_config01' }" @isErrshow="reload"></draggableDetail>
                    </div>
                </div>
            </div>
        </div>
        <div class="main_list">
            <el-collapse v-model="activeNames">
                <el-collapse-item disabled title="基本信息" name="1">
                    <el-form label-position="right" :model="data" class="details" label-width="auto">
                        <template>
                            <el-row v-for="(item_out, index_out) in colData" :key="index_out">
                                <el-col :span="12" v-for="(item, index) in item_out" :key="index">
                                    <el-form-item :label="item.title ? item.title + '：' : ''">
                                        <div
                                            class="read_only read_only_link"
                                            v-if="in_array(item.prop, ['business', 'supplier', 'product', 'credential', 'partner'])"
                                        >
                                            <span @click="toDetail(item.prop)">{{ data[item.prop] }}</span>
                                        </div>
                                        <el-input
                                            v-else
                                            v-model="data[item.prop]"
                                            class="flex_item_text"
                                            size="mini"
                                            readonly="readonly"
                                        ></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </template>
                    </el-form>
                </el-collapse-item>

                <el-collapse-item disabled title="流向列表" name="2">
                    <vFlowSourceListsComponent :postList="flow_params" v-if="flag"></vFlowSourceListsComponent>
                </el-collapse-item>
            </el-collapse>
        </div>
    </div>
</template>
<script>
import { onDelete, in_array, processColumnDataToRowNew } from '@/js/common';
import draggableDetail from '../../../common/DrawerDetail.vue';
import vFlowSourceListsComponent from '../../listComponent/basicdata/flowSourceLists/flowSourceListsComponent.vue';
export default {
    inject: ['reload'],
    name: 'commodityFlowConfig01Detail',
    components: {
        vFlowSourceListsComponent,
        draggableDetail
    },
    data() {
        return {
            colData: [],
            activeNames: ['1', '2'],
            data: {},
            queryParams: {},
            headerTitle: '流向商业配置详情',
            flag: false,
            flow_params: {}
        };
    },
    watch: {
        $route(to, from) {
            this.queryParams.rid = to.query.id;
            this.reload();
        }
    },
    beforeMount() {
        this.selectedColData(); //筛选列
        this.initQueryParams();
    },
    mounted() {
        this.$nextTick(() => {
            this.getData(); //获取详情
            this.flag = true;
            this.initSubListParams();
        });
    },
    methods: {
        in_array,
        initSubListParams() {
            this.flow_params.params = {
                config01_rid: this.queryParams.rid
            };
            this.flow_params.headerTitle = false;
            this.flow_params.tag = false;
            this.flow_params.source_account_rid = false;
            this.flow_params.source_file = false;
            this.flow_params.product_rid = false;
            this.flow_params.demander_rid = false;
            this.flow_params.supplier_rid = false;
            this.flow_params.no_demander = false;
            this.flow_params.no_supplier = false;
            this.flow_params.no_product = false;
            this.flow_params.source_account_code = false;
            this.flow_params.commodity_flow_source_rid = false;
            this.flow_params.rid = false;
            this.flow_params.business_rid = false;
            this.flow_params.no_business = false;
            this.flow_params.ta_rid = false;
            this.flow_params.date_range = false;
            this.flow_params.updateBtn = false;
            this.flow_params.productBtn = false;
            this.flow_params.supplierBtn = false;
            this.flow_params.demanderBtn = false;
            this.flow_params.searchBtn = false;
            this.flow_params.resetBtn = false;
            this.flow_params.downFileBtn = false;
            this.flow_params.setBtn = false;
        },
        toDetail(prop) {
            if (prop == 'business' && this.data.business_rid != '') {
                this.$router.push({
                    path: '/accountDetails',
                    query: {
                        id: this.data.business_rid
                    }
                });
            } else if (prop == 'product' && this.data.product_rid != '') {
                this.$router.push({
                    path: '/productListDetails',
                    query: {
                        id: this.data.product_rid
                    }
                });
            } else if (prop == 'supplier' && this.data.supplier_rid != '') {
                this.$router.push({
                    path: '/accountDetails',
                    query: {
                        id: this.data.supplier_rid
                    }
                });
            } else if (prop == 'partner' && this.data.partner_rid != '') {
                this.$router.push({
                    path: '/partnerDetails',
                    query: {
                        id: this.data.partner_rid
                    }
                });
            } else if (prop == 'credential' && this.data.credential_rid != '') {
                this.$router.push({
                    path: '/flowVoucherDetail',
                    query: {
                        id: this.data.credential_rid
                    }
                });
            }
        },
        initQueryParams() {
            this.queryParams.rid = this.$route.query.id;
        },
        //筛选列
        selectedColData() {
            let colData = JSON.parse(localStorage.getItem('detailList')).commodity_flow_config01;
            processColumnDataToRowNew(colData, this);
        },
        //详情
        getData() {
            this.$api
                .commodityFlowConfig01Detail(this.queryParams)
                .then((res) => {
                    this.data = res.data;
                    document.title = this.headerTitle + ':' + res.data.rid;
                })
                .catch((error) => {});
        },
        //新增
        insert() {
            this.$router.push({
                path: 'flowConfig01Edit',
                query: {
                    type: 'insert'
                }
            });
        },
        //复制
        copy() {
            this.$router.push({
                path: 'flowConfig01Edit',
                query: {
                    type: 'copy',
                    id: this.data.rid
                }
            });
        },
        //编辑
        update() {
            this.$router.push({
                path: 'flowConfig01Edit',
                query: {
                    type: 'update',
                    id: this.data.rid
                }
            });
        },
        //删除
        del() {
            onDelete(this.data.id, this, 'commodityFlowConfig01Delete', this.data.code, 'flowConfig01List');
        },
        disable() {
            this.$confirm('您确定要禁用吗，禁用后不能重新开启？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                closeOnPressEscape: false,
                closeOnClickModal: false
            })
                .then(() => {
                    this.$api['commodityFlowConfig01Disable']({ rid: this.data.rid })
                        .then((res) => {
                            if (res.code == 0) {
                                this.$message({
                                    message: '操作成功!',
                                    type: 'success'
                                });
                                this.reload();
                            }
                        })
                        .catch((error) => {});
                })
                .catch(() => {});
        }
    }
};
</script>
<style lang="scss" scoped="scoped">
</style>